import React from "react"
import PropTypes from "prop-types"
import ImageLoader from "@components/ImageLoader/ImageLoader"

import css from "./SnackBar.scss"

const icons = {
    warning: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 46 46">
            <path
                fill="#FFB3A9"
                d="M45.92 23c0 12.657-10.261 22.919-22.919 22.919-12.658 0-22.919-10.262-22.919-22.92C.082 10.343 10.342.082 23.002.082 35.658.081 45.92 10.341 45.92 23Z"
            />
            <path
                fill="#3B3B3B"
                d="M23 29.942a.8.8 0 0 1-.8-.8V8.967a.8.8 0 1 1 1.6 0v20.175a.8.8 0 0 1-.8.8ZM23 34.172c-1.044 0-1.89.82-1.89 1.83 0 1.01.846 1.83 1.89 1.83s1.89-.82 1.89-1.83c0-1.01-.846-1.83-1.89-1.83Z"
            />
        </svg>
    ),
}

function SnackBar(props) {
    const { message, type, icon, actionText, action, actionFullWidth, className } = props
    const iconToRender = icons[type] || <></>
    return (
        <div className={`${css.container} ${className} flex justifyCenter`}>
            <div className={`${css.content} padding-16-0 padding-0-16 flex justifyBetween alignCenter`}>
                {icon ? <ImageLoader src={icon} height={24} width={24} /> : iconToRender}
                <div className={`${css.text} padding-0-8`}>
                    <div className={`${css.message} bodyRegular`}>{message}</div>
                </div>
                {actionText && (
                    <div
                        tabIndex={0}
                        role="button"
                        className={`${css.action} bodySemiBold pointer ${
                            actionFullWidth ? "width-100 marginTop-8" : ""
                        }`}
                        onClick={action}
                        onKeyUp={(e) => e.keyCode === 13 && action(e)}
                    >
                        {actionText}
                    </div>
                )}
            </div>
        </div>
    )
}

SnackBar.defaultProps = {
    type: "",
    icon: "",
    actionText: "",
    action: () => {},
    className: "",
    actionFullWidth: false,
}

SnackBar.propTypes = {
    message: PropTypes.string.isRequired,
    icon: PropTypes.string,
    actionText: PropTypes.string,
    action: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.oneOf(["error", "warning", "success"]),
    actionFullWidth: PropTypes.bool,
}

export default SnackBar
